function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "Path_1158",
  "data-name": "Path 1158",
  d: "M12 22a10 10 0 1110-10 10 10 0 01-10 10zm0-2a8 8 0 10-8-8 8 8 0 008 8zM11 7h2v2h-2zm0 4h2v6h-2z",
  transform: "translate(-2 -2)",
  fill: "#f4f4f4"
})));